import React from "react";
import axios from "axios";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CallIcon from "@material-ui/icons/Call";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import { useLocation, useParams } from 'react-router-dom';
import Constants from "../../Utils/Constants";
import LoadingProgress from "../../Common/LoadingProgress";
import { getToken, getHeaders } from "../../Utils/Common";
import store from "../../Common/storage";
import Header from "../../assets/components/header";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Pagination from '@material-ui/lab/Pagination';
import "./../../index.css";
import toastMaker from "../../Common/toastmaker";



const StyledTableCell = withStyles((theme) => ({
  body: {
    fontSize: 16,
    fontWeight: 600,
    padding: 15,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "rgba(251, 220, 119, 0.28)",
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: "100%",
  },
});

export default function StickyHeadTable(props) {
  const classes = useStyles();
  const [serverData, setServerData] = React.useState(store.get("history"));
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(0);
  const location = useLocation();
  const [accid, setAccid] = React.useState()
  const [openModal, setOpenModal] = React.useState(false)
  const [openModalType, setOpenModalType] = React.useState()
  const [transactions, setTransactions] = React.useState()
  const [creditsTransactions, setCreditsTransactions] = React.useState()
  const [isMaster, setIsMaster] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false);
  let interval = null;

  const handleChange = (event, value) => {
    setPage(value);
  };

  React.useEffect(() => {
    setIsMaster(store.get('user').configs.filter(c => c.id == store.get('user').partner_id)[0].is_master)
    let id = location.pathname.split('/').pop()
    load(id)
    setAccid(id)
  }, []);

  const load = id => {
    axios.get(Constants.getApiPathWithConfigId(Constants.configurationsApiPath, id), getHeaders())
                      .then(response => {
                        setServerData(response.data.data)
                      }).catch(error => console.error(error))
  };

  const addCredits = credits => {
    if(credits == 0) {
      alert('Please provide valid credits amount')
    }
    if(credits > 0) {
      // add
      axios.post(Constants.creditsAddApiPath, {
        to_account: accid,
        credits: credits,
        note: `${credits} Credits added`,
        reference: "company_config",
        reference_id: store.get('user').partner_id
      }, getHeaders())
            .then(response => {
              load(accid)
            }).catch(error => console.error(error))
    }
    if(credits < 0) {
      //substact
      axios.post(Constants.creditsRemoveApiPath, {
        to_account: accid,
        credits: (credits * -1),
        note: `${credits * -1} Credits removed`,
        reference: "company_config",
        reference_id: store.get('user').partner_id
      }, getHeaders())
                      .then(response => {
                        load(accid)
                      }).catch(error => console.error(error))
    }
  }

  React.useEffect(() => {
    if(openModal && openModalType == 'transactions') {
        getTransactions()
    }
    
  }, [openModal, page])

  const getTransactions = () => {
    axios.get(Constants.getApiPathWithConfigId(Constants.gettransactionsApiPath, accid)+ `?per_page=50&page=${page}&order_by=id&order=desc`,  getHeaders())
      .then(t => {
        setPageCount(t.data.meta.last_page)
        setTransactions(t.data.data)
        setCreditsTransactions(t.data.meta.credits)
      })
  }

  const onEditAcDetailsSubmit = () => {
      setIsLoading(true);
      axios.post(Constants.checkAcCredsApiPath, {
        host: serverData.host,
        key: serverData.api_key
      }, getHeaders())
            .then(response => {
              axios.put(Constants.getApiPathWithConfigId(Constants.configurationsApiPath, accid), {
                alias: serverData.alias,
                host: serverData.host,
                api_key: serverData.api_key
              }, getHeaders())
                    .then(response => {
                      setIsLoading(false);
                      toastMaker.makeToast("Details updated successfully", {
                                            variant: "success",
                                      })
                    }).catch(e => {})
                    .catch(
                      error => toastMaker.makeToast("Something went wrong, please try again", {
                                            variant: "error",
                                      })
                      )
            })
            .catch(
              error => toastMaker.makeToast("Wrong details, Please check API URL and API KEY", {
                                    variant: "error",
                              })
              )
    };

  const getTallbobReports = () => {
    return <div>
      This is tallbob report
    </div>
  }

  if (!serverData) {
    return <LoadingProgress />;
  }

  return (
    <div className="panal-viewport middle-container"> 
      <Header name={`Manage Accont ${serverData.name}`} />
      <Paper className={`${classes.root} pb-2`}>
        <div className="MuiPaper-root box-viewport-set md-view MuiPaper-elevation3 MuiPaper-rounded" style={{margin: "0px auto 10px", maxWidth: "700px", padding: "10px"}}>
          <div>
            <p className="MuiTypography-root jss26 MuiTypography-body1">Basic Details</p>
            <form>
              <label>
                Country: {serverData.country}
              </label>
              <label>
                Zipcode: {serverData.zipcode}
              </label>
            </form>
          </div>
        </div>

        <div className="MuiPaper-root box-viewport-set md-view MuiPaper-elevation3 MuiPaper-rounded" style={{margin: "0px auto 10px", maxWidth: "700px", padding: "10px"}}>
          <div>
            <p className="MuiTypography-root jss26 MuiTypography-body1">ActiveCampaign Details</p>

            <form>
              <label>Alias</label>
              <div className="form-groups">
                <input
                  id="alias"
                  value={serverData.alias}
                  onChange={(event) => {
                    setServerData({...serverData, alias: event.target.value})
                  }}
                  type="text"
                  className="form-controls"
                />
              </div>

              <label>API URL</label>
              <div className="form-groups">
                <input
                  id="host"
                  value={serverData.host}
                  onChange={(event) => {
                    setServerData({...serverData, host: event.target.value})
                  }}
                  type="text"
                  className="form-controls"
                />
              </div>

              <label>API Key</label>
              <div className="form-groups">
                <input
                  id="apikey"
                  value={serverData.api_key}
                  onChange={(event) => {
                    setServerData({...serverData, api_key: event.target.value})
                  }}
                  type="text"
                  className="form-controls"
                />
              </div>
              <p
                className="c-button c-button--secondary text-uppercase text-light"
                style={{marginTop: '10px'}}
                onClick={() => {
                  onEditAcDetailsSubmit()
                }}
              >Save</p>
            </form>
          </div>
        </div>

        <div className="MuiPaper-root box-viewport-set md-view MuiPaper-elevation3 MuiPaper-rounded" style={{margin: "0px auto 10px", maxWidth: "700px", padding: "10px"}}>
          <div>
            <p className="MuiTypography-root jss26 MuiTypography-body1">Credits Details</p>
            <form>
              <label>
                Current Balance: {serverData.last_balance}
              </label>
              <label>
                Is Postpaid: {serverData.allow_exceed ? 'Yes' : 'No'}
              </label>
              <div style={{
                display: 'flex',
                gap: '10px'
              }}>
                {serverData.last_balance && <p
                  className="c-button c-button--secondary text-uppercase text-light"
                  style={{marginTop: '10px'}}
                  onClick={() => {
                    let conf = window.confirm(`Are you sure to add 100 credits to ${serverData.name}?`)
                    if(conf) {
                      addCredits(100)
                    }
                  }}
                >Add 100 (Trial)</p>}
                <p
                  className="c-button c-button--secondary text-uppercase text-light"
                  style={{marginTop: '10px'}}
                  onClick={() => {
                    let conf = window.prompt(`How many credits you want to add to ${serverData.name}?`)
                    if(conf) {
                      addCredits(conf)
                    }
                  }}
                >Add Credits</p>
                <p
                  className="c-button c-button--secondary text-uppercase text-light"
                  style={{marginTop: '10px'}}
                  onClick={() => {
                    let conf = window.prompt(`How many credits you want to substact from ${serverData.name}?`)
                    if(conf) {
                      addCredits(conf * -1)
                    }
                  }}
                >Substact Credits</p>
                <p
                  className="c-button c-button--secondary text-uppercase text-light"
                  style={{marginTop: '10px'}}
                  onClick={() => {
                    setOpenModalType('transactions')
                    setOpenModal(true)
                  }}
                >Transactions</p>
                <p
                  className="c-button c-button--secondary text-uppercase text-light"
                  style={{marginTop: '10px'}}
                  onClick={() => {
                    setOpenModalType('tallbob')
                    setOpenModal(true)
                  }}
                >TallBob Reports</p>
              </div>
            </form>
          </div>
        </div>

        {isMaster == 1 && <div className="MuiPaper-root box-viewport-set md-view MuiPaper-elevation3 MuiPaper-rounded" style={{margin: "0px auto 10px", maxWidth: "700px", padding: "10px"}}>
            <div>
              <p className="MuiTypography-root jss26 MuiTypography-body1">Longcodes</p>
              <form>
                <ol style={{margin: '0 30px'}}>
                  {
                    serverData.longcodes.map(l => <li style={{margin: '5px 0'}}>
                      {l.number}
                      <p
                        className="c-button text-uppercase text-light"
                        style={{margin: '0 20px', display: 'inline-block'}}
                        onClick={() => {
                          axios.delete(Constants.getApiPathWithConfigId(Constants.virtualnumbers, accid) + `/${l.id}`, getHeaders())
                                .then(response => {
                                  load(accid)
                                }).catch(error => console.error(error))
                        }}
                      >Delete</p>
                  </li>)
                  }
                </ol>
                <p
                  className="c-button c-button--secondary text-uppercase text-light "
                  style={{marginTop: '10px'}}
                  onClick={() => {
                    let virtual_number = window.prompt('Please provide number')
                    axios.post(Constants.getApiPathWithConfigId(Constants.virtualnumbers, accid), {
                            number: virtual_number,
                          }, getHeaders())
                                .then(response => {
                                  load(accid)
                                }).catch(error => console.error(error))
                  }}
                >Add Longcode</p>
              </form>
            </div>
          </div>
        }

        <div className="MuiPaper-root box-viewport-set md-view MuiPaper-elevation3 MuiPaper-rounded" style={{margin: "0px auto 10px", maxWidth: "700px", padding: "10px"}}>
          <div>
            <p className="MuiTypography-root jss26 MuiTypography-body1">Users</p>
            <form>
              <ol style={{margin: '0 30px'}}>
                {
                  serverData.users.map(l => <li>
                    {l.name}
                  </li>)
                }
              </ol>
            </form>
          </div>
        </div>

        <Dialog
          onClose={() => setOpenModal(false)}
          aria-labelledby="simple-dialog-title"
          open={openModal}
          scroll={"body"}
          fullWidth={true}
          maxWidth="xl"
        >
          {openModalType == 'transactions' ? <div className="">
              <DialogTitle id="simple-dialog-title">Transactions</DialogTitle>
              <DialogContent>
                <TableContainer component={Paper}>
                  <Table className={classes.table} aria-label="customized table">
                    <TableHead style={{
                                    width: "calc(100% - 1em)",
                                    display: "table",
                                    tableLayout: "fixed"
                                  }}>
                      <TableRow id="table-head_rw">
                        <StyledTableCell className="table-hd">
                          From
                        </StyledTableCell>
                        <StyledTableCell className="table-hd">
                          To
                        </StyledTableCell>
                        <StyledTableCell className="table-hd">
                          Credits
                        </StyledTableCell>
                        {/* <StyledTableCell className="table-hd">
                          Narration
                        </StyledTableCell> */}
                        <StyledTableCell className="table-hd">
                          Send Date, Time
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody style={{
                                    height: "310px",
                                    overflow: "auto",
                                    width: "100%",
                                    tableLayout: "fixed",
                                    display: "block"
                                  }}>
                      {
                        transactions && transactions?.length && transactions?.map((row) => 
                          <StyledTableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.id}
                            style={{
                                  display: "table",
                                  width: "100%",
                                  tableLayout: "fixed"
                            }}
                          >
                            <StyledTableCell
                              component="th"
                              scope="row"
                              style={{maxWidth: '170px'}}
                            >
                              <div className="speech-bubble">
                                <span>{row.from_account_name}</span>
                              </div>
                            </StyledTableCell>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              style={{maxWidth: '170px'}}
                            >
                              <div className="speech-bubble">
                                <span>{row.to_account_name}</span>
                              </div>
                            </StyledTableCell>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              style={{maxWidth: '170px'}}
                            >
                              <div className="speech-bubble">
                                <span>{row.credits}</span>
                              </div>
                            </StyledTableCell>
                            {/* <StyledTableCell
                              component="th"
                              scope="row"
                              style={{maxWidth: '170px'}}
                            >
                              <div className="speech-bubble">
                                <span>{row.narration.replace('substacted', 'subtracted')}</span>
                              </div>
                            </StyledTableCell> */}
                            <StyledTableCell
                              component="th"
                              scope="row"
                              style={{maxWidth: '170px'}}
                            >
                              <div className="speech-bubble">
                                <span>{new Date(row.created_at).toLocaleString()}</span>
                              </div>
                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
                {pageCount > 0 && <div className={`${classes.root} mt-3 mb-3 d-flex justify-content-end`}>
                  <Pagination 
                    count={pageCount} 
                    page={page} 
                    onChange={handleChange} 
                    variant="outlined" 
                    shape="rounded"
                    />
                </div>}

                <TableContainer component={Paper} style={{margin: '10px 0'}}>
                  <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                      <TableRow id="table-head_rw">
                        <StyledTableCell className="table-hd">
                          Transactions Total
                        </StyledTableCell>
                        <StyledTableCell className="table-hd">
                          Balance 
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                      >
                        <StyledTableCell
                          component="th"
                          scope="row"
                          style={{maxWidth: '170px'}}
                        >
                          <div className="speech-bubble">
                            <span>
                              {
                                creditsTransactions
                              }
                            </span>
                          </div>
                        </StyledTableCell>
                         <StyledTableCell
                          component="th"
                          scope="row"
                          style={{maxWidth: '170px'}}
                        >
                          <div className="speech-bubble">
                            <span style={{
                              float: 'left',
                              margin: '10px 20px 0 0'
                            }}
                            >{serverData.last_balance}</span>
                            
                          {creditsTransactions != serverData.last_balance && <p
                            className="c-button c-button--secondary text-uppercase text-light"
                            style={{marginTop: '0', float: 'left'}}
                            onClick={() => {
                              axios.put(Constants.getApiPathWithConfigId(Constants.configurationsApiPath, accid), {
                                last_balance: creditsTransactions
                              }, getHeaders())
                                    .then(t => {
                                      load(accid)
                                    })
                            }}
                          >Rebalance</p>}
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                
              </DialogContent>
              
            </div> : <div className="import-template-modal">
              <DialogTitle id="simple-dialog-title">TallBob Reports</DialogTitle>
                <DialogContent>
                  {
                    getTallbobReports()
                  }
                </DialogContent>
                
              </div>
            }
        </Dialog>
      </Paper>
    </div>
  );
}
